import React, { useEffect, useRef, useState } from 'react'
import { Alert, Avatar, Backdrop, Box, Button, Card, CardContent, CircularProgress, Divider, Fab, Icon, IconButton, LinearProgress, List, ListItem, ListItemAvatar, ListItemText, Snackbar, TextField, Typography } from '@mui/material'
import { ChatBubble, Chat, Close, Share, Send, ThreeP, ThreePRounded, Psychology, Face } from '@mui/icons-material'
import { addNewChatConv, askAiAsync, selectChatConv, selectStatus, setChatGenesis } from './ChatConvSlice'
import { useAppDispatch, useAppSelector } from '../../app/hooks'

export interface ChatConvWindowProps {
  history: any[]
  onClose: Function
  onRegenerate?: (slug: string) => void
  chatGenesis: any
  slug: string
  className?: string
}
function ChatConvWindow(prop: ChatConvWindowProps) {
  const chatTextField = useRef<any>()
  const chatList = useRef<any>()
  const chatConv = useAppSelector(selectChatConv)
  const chatStatus = useAppSelector(selectStatus)
  const dispatch = useAppDispatch()
  useEffect(() => {
    chatTextField?.current?.scrollIntoView({ behaviour: "smooth" })
    dispatch(setChatGenesis(prop.chatGenesis))
  }, [])

  useEffect(() => {
    chatList?.current?.scrollIntoView({ behaviour: "smooth" })
  }, [chatConv])

  const askAi = () => {
    if (chatTextField.current.value && chatStatus === 'idle') {
      dispatch(addNewChatConv({ content: chatTextField.current.value, role: 'user' }))
      dispatch(askAiAsync({ content: chatTextField.current.value, slug: prop.slug }))
      chatTextField.current.value = ''
    }
  }
  return (<Box className={prop.className} sx={{
    position: 'fixed',
    top: 'auto',
    bottom: 10,
    left: 'auto',
    right: 30,
    width: 350,
    height: 500,
    boxShadow: 15,
    bgcolor: 'background.paper',
  }}>
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        height: 35,
        borderBottom: (theme) => `1px solid ${theme.palette.divider}`,
        bgcolor: 'primary.main',
        color: 'text.secondary'
      }}
    >
      <Typography sx={{ paddingLeft: 1, color: 'primary.contrastText' }}>Chat with Rentfinder™ AI</Typography>
      <Button onClick={prop.onClose as any}>
        <Close sx={{ color: 'primary.contrastText', opacity: 0.7, ":hover": { cursor: 'pointer', opacity: 1.0 } }}
        />
      </Button>
    </Box>
    <Box sx={{
      overflowY: 'scroll',
      maxHeight: '460'
    }}>
      <List
        sx={{
          width: '100%',
          maxHeight: 395,
          height: 395,
          bgcolor: 'background.paper',
        }}
      >
        {chatConv && chatConv.length ? <>
          {chatConv.map((elem: any, index: any) => <>
            <ListItem key={index}>
              {elem.role !== 'user' && <ListItemAvatar sx={{ alignSelf: 'flex-end', width: 20 }}>
                <Avatar>
                  <Psychology />
                </Avatar>
              </ListItemAvatar>}
              <ListItemText sx={{ maxWidth: 275, overflow: 'hidden' }}
                primary={elem.content} primaryTypographyProps={{
                  variant: 'subtitle2',
                  style: {
                    whiteSpace: 'pre-wrap'
                  }
                }} />
              {elem.role === 'user' && <ListItemAvatar sx={{ alignSelf: 'flex-end', width: 20 }}>
                <Avatar>
                  <Face />
                </Avatar>
              </ListItemAvatar>}
            </ListItem>
            <Divider variant="fullWidth" component="li" />
          </>)
          }<Box ref={chatList} sx={{ display: 'flex', justifyContent: 'flex-end' }}>
            <Button sx={{ my: 2 }} variant='outlined' size='small' onClick={() => {
              dispatch(addNewChatConv({ content: 'regenerate estimate', role: 'user' }))
              dispatch(askAiAsync({
                content: 'regenerate estimate', slug: prop.slug, callback: (slug: string) => {
                  prop.onRegenerate && prop.onRegenerate(slug)
                }
              }))
            }}>regenerate estimate</Button>
          </Box>
        </> : <Typography>Do you have any question related to the estimates I provided? I was born to help, ask away.</Typography>}
      </List>
    </Box>
    {chatStatus !== 'idle' && <Box sx={{ width: '100%' }}>
      <LinearProgress />
    </Box>}
    <TextField inputRef={chatTextField}
      disabled={chatStatus !== 'idle'}
      sx={{ width: '100%' }}
      label="Ask your question" variant="outlined"
      InputProps={{
        endAdornment: <Button onClick={askAi}
          disabled={chatStatus !== 'idle'}>
          <Send />
        </Button>
      }} onKeyPress={(ev) => {
        if (ev.key === 'Enter') {
          askAi()
          ev.preventDefault()
        }
      }} />
  </Box>)
}

export default ChatConvWindow
